// Safe storage access — wraps sessionStorage / localStorage with try/catch and
// an in-memory Map fallback for environments where storage is unavailable
// (Safari Private Browsing quota=0, sandboxed iframes, disabled cookies, etc).
//
// The analytics layer must never throw; these helpers always succeed (writing
// to memory if persistent storage is inaccessible) and never re-throw.

const memSession = new Map()
const memLocal = new Map()

function storage(kind) {
  try {
    if (typeof window === 'undefined') return null
    return kind === 'session' ? window.sessionStorage : window.localStorage
  } catch {
    return null
  }
}

function read(kind, key) {
  const mem = kind === 'session' ? memSession : memLocal
  const s = storage(kind)
  if (s) {
    try {
      const v = s.getItem(key)
      if (v != null) return v
    } catch {
      // fall through to memory
    }
  }
  return mem.has(key) ? mem.get(key) : null
}

function write(kind, key, value) {
  const mem = kind === 'session' ? memSession : memLocal
  mem.set(key, value)
  const s = storage(kind)
  if (s) {
    try {
      s.setItem(key, value)
    } catch {
      // silent — memory copy already set
    }
  }
}

function remove(kind, key) {
  const mem = kind === 'session' ? memSession : memLocal
  mem.delete(key)
  const s = storage(kind)
  if (s) {
    try {
      s.removeItem(key)
    } catch {
      // silent
    }
  }
}

export const getSession = (key) => read('session', key)
export const setSession = (key, value) => write('session', key, value)
export const clearSession = (key) => remove('session', key)
export const getLocal = (key) => read('local', key)
export const setLocal = (key, value) => write('local', key, value)

